
class MediaGallery extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      liveRegion: this.querySelector('[id^="GalleryStatus"]'),
      viewer: this.querySelector('[id^="GalleryViewer"]'),
      media:  this.querySelectorAll('[data-media-id]')
    }

    window.addEventListener('DOMContentLoaded', () => {
      this.elements.galleryThumbs = this.querySelector('gallery-thumbs');
      if(!this.elements.galleryThumbs) return;
      this.elements.thumbs = this.elements.galleryThumbs.querySelectorAll('.js-gallery-thumb');
    });

    document.body.addEventListener('setActiveMediaTrigger', this.setActiveMedia.bind(this));

  }

  setActiveMedia(event) {
    const mediaId = event.detail.mediaId;
    const mediaGallery = event.detail.mediaGallery;
    const activeMedia = this.querySelector(`[data-media-id="${ mediaId }"]`);
    const mql = window.matchMedia('(min-width: 990px)');
    const desktopStacked = mediaGallery.dataset.desktopLayout === 'stacked';

    this.elements.media.forEach((element) => {
      element.classList.remove('is-active');
    });

    if (mql.matches && desktopStacked) {
      activeMedia.classList.add('is-active');

      if(!event.detail.initialLoad && !event.detail.isStickyForm) {
        activeMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const slideIndex = +activeMedia.closest('.embla__slide')?.getAttribute('data-slide-index');
        if(this.elements.galleryThumbs && slideIndex > -1) this.elements.galleryThumbs.updateThumbs(slideIndex)
      }

      const activeMediaSlide = activeMedia.closest('.embla__slide');
      if(!activeMediaSlide) return;
      const activeMediaIndex = Number(activeMediaSlide.getAttribute('data-slide-index'));

      if(!this.elements.galleryThumbs) return;
      this.elements.galleryThumbs.updateThumbs(activeMediaIndex)

    } else {
      const carousel = mediaGallery.querySelector('embla-component');
      const currentSlide = activeMedia.closest('.embla__slide');

      if(carousel && currentSlide) carousel.slideToIndex(+currentSlide.getAttribute('data-slide-index'))
    }
  }

  thumbClickHandler(index) {
    const relevantSlide = this.elements.media[+index];
    if(!relevantSlide) return;

    this.elements.media.forEach((element) => {
      element.classList.remove('is-active');
    });

    relevantSlide.scrollIntoView({ behavior: 'smooth', block: 'center' });
    relevantSlide.classList.add('is-active');
  }

  announceLiveRegion(activeItem, position) {
    const image = activeItem.querySelector('.product__modal-opener--image img');
    if (!image) return;
    image.onload = () => {
      this.elements.liveRegion.setAttribute('aria-hidden', false);
      this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
        '[index]',
        position
      );
      setTimeout(() => {
        this.elements.liveRegion.setAttribute('aria-hidden', true);
      }, 2000);
    };
    image.src = image.src;
  }

  preventStickyHeader() {
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if (!this.stickyHeader) return;
    this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
  }
};

customElements.define('media-gallery', MediaGallery);
